module.exports = __webpack_public_path__ + "static/media/logo_monitoramento.76bda2b1.png";